import "../../../callout.js";
import "../../../mixins/recoverable_error.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.ConfirmationStep ??= {};

AppointmentBooking.Wizard.Views.ConfirmationStep.ProviderSwitchCallout = class ProviderSwitchCallout extends (
  AppointmentBooking.Wizard.Views.Mixins.RecoverableError(AppointmentBooking.Wizard.Views.Callout)
) {};
AppointmentBooking.Wizard.Views.ConfirmationStep.ProviderSwitchCallout.prototype.template =
  "step/confirmation/callouts/provider_switch";
AppointmentBooking.Wizard.Views.ConfirmationStep.ProviderSwitchCallout.prototype.className =
  "appointment-booking-wizard-confirmation-step-provider-switch-callout";
AppointmentBooking.Wizard.Views.ConfirmationStep.ProviderSwitchCallout.prototype.recoverableErrorTypes = [
  "ehr_appointment_slot_id_invalid_provider",
];
